import React from 'react';
import '../App.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Privacy & Terms</p>
      <p>©2024</p>
    </footer>
  );
};

export default Footer;
